import { Carousel } from "antd";
import { CarouselImages } from "../../config/carousel-images";

const ImgCarousel = () => {
  return (
    <div className="max-w-screen-xl px-12 mx-auto lg:gap-8 mt-[150px] rounded-[20px] max-md:-mb-20">
      <div className="text-center mb-[80px]">
            
        <div className="font-[500] text-primary_light text-[35px] mb-3">
          <span className="px-2 py-1 rounded mr-1 text-white bg-primary_light">{CarouselImages.subTitle.first}</span>
        </div>
        
        <h1 className="text-center max-w-4xl mb-4 text-[60px] max-lg:text-[45px] max-lg:leading-[60px] leading-[70px] font-semibold text-secondary mx-auto custom-font">{CarouselImages.title}</h1>
      </div>
      <div className="rounded-[20px]">
        <Carousel arrows infinite={true} autoplay dots={false}>
          {CarouselImages.images.map((items: any, index) => (
            <div key={index} className="w-full rounded-[20px] ">
              <div className="rounded-[20px] w-full h-[500px]  max-md:h-[300px]  flex justify-center items-center overflow-hidden">
                <div className="flex justify-center  w-full h-full rounded-[20px] ">
                  <img src={items.url} alt={items.name || 'Image'} className="object-fill rounded-[20px] "/>
                </div>
              </div>
            </div>
          ))}
        </Carousel>
      </div>
    </div>
  )
}
export default ImgCarousel;
